import PropTypes from 'prop-types';
import React from 'react';
import RecordRTC, { StereoAudioRecorder } from 'recordrtc';
import { isIOS13 } from '../utils/browserUtils';
import { MIC_FAILURE_TYPES } from '../../trc/pages/instructions/TROInstructionsConstants';


const audioRecorderOptions = {
    type: 'audio',
    mimeType: 'audio/wav',
    recorderType: StereoAudioRecorder,
    desiredSampRate: 16000,
    numberOfAudioChannels: 1,
};

class RecordingView extends React.PureComponent {

    async componentDidMount() {
        await this.initializeRecorder();
    }

    componentDidUpdate = prevProps =>  {
        const {
            shouldStartRecording,
            shouldPauseRecording,
            shouldResumeRecording,
            shouldStopRecording,
            setRecordingError,
            startRecording,
            stopRecording,
            shouldReinitializeRecorder,
        } = this.props;

        try {
            if (shouldReinitializeRecorder && shouldReinitializeRecorder !== prevProps.shouldReinitializeRecorder) this.initializeRecorder();

            if (shouldStartRecording && shouldStartRecording !== prevProps.shouldStartRecording) {
                startRecording();
                this.audioRecorder.startRecording();
            }

            if (shouldPauseRecording && shouldPauseRecording !== prevProps.shouldPauseRecording) {
                stopRecording();
                this.audioRecorder.pauseRecording();
            }

            if (shouldResumeRecording && shouldResumeRecording !== prevProps.shouldResumeRecording) {
                startRecording();
                this.audioRecorder.resumeRecording();
            }

            if (shouldStopRecording && shouldStopRecording !== prevProps.shouldStopRecording) {
                this.audioRecorder.stopRecording(this.handleRecordingStopped);
            }
        } catch (error) {
            this.audioRecorder.stopRecording(this.endAudioRecording);
            setRecordingError(MIC_FAILURE_TYPES.ACCESS_FAILED);
        }
    }

    initializeRecorder = async () => {
        const { recordingStream, duration } = this.props;
        let currentRecordingStream = recordingStream;
        /*
            Need to reset stream on iOS devices for audio recording to work.
        */
        if (!recordingStream || isIOS13()) currentRecordingStream = await this.resetRecordingStream(recordingStream);

        this.audioRecorder = new RecordRTC(currentRecordingStream.clone(), audioRecorderOptions);
        this.audioRecorder.setRecordingDuration(duration).onRecordingStopped(this.handleRecordingStopped);
    }

    resetRecordingStream = async (currentStream) => {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            this.props.setRecordingStream(stream);
            return stream;
        }
        return currentStream;
    };

    endAudioRecording = () => {
        const { stopRecording } = this.props;
        stopRecording();
    }

    saveAudioRecording = () => {
        const { saveRecordedResult } = this.props;
        const blob = this.audioRecorder.getBlob();
        saveRecordedResult(blob);
    }

    handleRecordingStopped = () => {
        this.endAudioRecording();
        this.saveAudioRecording();
    }

    render() {
        return null;
    }
}

RecordingView.propTypes = {
    shouldStartRecording: PropTypes.bool.isRequired,
    shouldPauseRecording: PropTypes.bool,
    shouldResumeRecording: PropTypes.bool,
    shouldStopRecording: PropTypes.bool.isRequired,
    duration: PropTypes.number.isRequired,
    startRecording: PropTypes.func,
    stopRecording: PropTypes.func,
    saveRecordedResult: PropTypes.func,
    setRecordingError: PropTypes.func,
    setRecordingStream: PropTypes.func,
    recordingStream: PropTypes.shape({ clone: PropTypes.func.isRequired }),
    shouldReinitializeRecorder: PropTypes.bool,
};

RecordingView.defaultProps = {
    startRecording: () => {},
    stopRecording: () => {},
    setRecordingStream: () => {},
    setRecordingError: () => {},
    saveRecordedResult: () => {},
    recordingStream: undefined,
    shouldPauseRecording: false,
    shouldResumeRecording: false,
    shouldReinitializeRecorder: false,
};

export default RecordingView;
